import React, { Suspense, lazy } from 'react';
import { observer } from 'mobx-react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

import { app } from './stores/app';

import Loader from './containers/loader';

const NewApp = lazy(() => import('./newDesign/appPortal'));
const App = lazy(() => import('./appPortal'));

export const RootSwitch = observer(() => {
  if (app.portalUnavailable) {
    return (
      <main
        role="status"
        style={{
          alignItems: 'center',
          backgroundColor: '#f5f7fa',
          color: '#263238',
          display: 'flex',
          fontSize: '18px',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '24px',
          textAlign: 'center',
        }}
      >
        The portal is temporarily unavailable due to maintenance. Please try again later.
      </main>
    );
  }

  const portalSettings = app.portalSettings;
  const customerId = app.userInfo?.customer_id;
  const isAuthorized = app.isAuthorized();
  const isAnonymous = app.isAnonymous();

  const isNewDesign = app.isNewDesign();
  const isLoaded = isAuthorized && !isAnonymous ? customerId : portalSettings;

  return (
    <>
      <Suspense fallback={<Loader full />}>
        {!isLoaded && <Loader full noTransparent />}
        {isNewDesign
          ? <NewApp />
          : <App />
        }
      </Suspense>
      <Modal
        isOpen={app.anonymousSessionExpired}
        backdrop="static"
        keyboard={false}
        centered
      >
        <ModalBody>Session expired. Please refresh the page.</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => window.location.reload()}>
            Refresh
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
});
